import {Component, OnInit} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Order} from "../../../../../../common/interfaces/order.interface";


@Component({
    selector: "section-order-list-on-hold",
    template: `
        <section-order-list [params]="params"></section-order-list>`
})
export class OrderListOnHoldComponent implements Base.IComponent, OnInit {

    public readonly state: Base.IState;

    public params: Order.IOrderListParams;

    public constructor() {
    }

    public ngOnInit(): void {
        this.params = {
            title: "On hold orders list",
            state: this.state,
            actions: {
                view: true,
                delete: true,
                add: false,
                export: true,
                remarks: true
            },
            query: {on_hold: true}
        };
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "orders-on-hold",
            actions: {
                "browse": ["browse_orders"]
            }
        };
    }

}
